module.exports = __webpack_public_path__ + "static/img/hero2_info.d7473c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/hero2_info.png
// module id = 9xbh
// module chunks = 1